import { useGetDataHook } from '@bymason/api-hooks-base';
import { useCallback } from 'react';
import { metadataClient } from '@bymason/controller-api';

/**
 * React hook that asynchronously gets the dashboard metadata.
 * @returns HookArray
 * @HookArray [0] get method
 * @HookArray [1] result
 * @HookArray [2] error
 * @HookArray [3] busy flag
 * @HookArray [4] error code
 * @HookArray [5] error data
 * @HookArray [6] clearData method
 */
export function useGetDashboardMetadata(clientToken: string) {
  const handleGetData = useCallback(() => {
    return metadataClient.getDashboardMetadata(clientToken);
  }, [clientToken]);

  return useGetDataHook(handleGetData);
}
